import React, { useEffect, useState } from "react";

/** How many slides on each side of the current one may load. */
const LOAD_RADIUS = 2;

function resolveSource(data, isFullscreen) {
  if (!data || data.source == null) return undefined;
  if (typeof data.source === "string") return data.source;
  if (isFullscreen) {
    return data.source.fullscreen || data.source.regular;
  }
  return data.source.regular;
}

/**
 * Drop-in replacement for react-images View: only attaches `src` for the
 * current slide and its neighbors. Once activated, the src is kept so
 * revisiting a slide is instant (browser cache).
 */
const LazyCarouselView = (props) => {
  const {
    data,
    formatters,
    getStyles,
    index,
    isFullscreen,
    isModal,
    currentIndex = 0,
  } = props;

  const source = resolveSource(data, isFullscreen);
  const [activated, setActivated] = useState(
    () => Math.abs(index - currentIndex) <= LOAD_RADIUS
  );

  useEffect(() => {
    if (Math.abs(index - currentIndex) <= LOAD_RADIUS) {
      setActivated(true);
    }
  }, [currentIndex, index]);

  return (
    <div
      style={getStyles("view", props)}
      className={`react-images__view${
        isFullscreen ? " react-images__view--isFullscreen" : ""
      }${isModal ? " react-images__view--isModal" : ""}`}
    >
      {activated && source ? (
        <img
          alt={formatters.getAltText({ data, index })}
          src={source}
          decoding="async"
          style={{
            height: "auto",
            maxHeight: "100vh",
            maxWidth: "100%",
            userSelect: "none",
          }}
        />
      ) : (
        <div aria-hidden style={{ minHeight: "50vh" }} />
      )}
    </div>
  );
};

export default LazyCarouselView;
